import script from "./CaseStudyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseStudyCard.vue?vue&type=script&setup=true&lang=js"

import "./CaseStudyCard.vue?vue&type=style&index=0&id=17dac1f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17dac1f8"]])

export default __exports__